import React from "react";

const FrequencyInput = ({ value, onChange, options = [], onSelect }) => {
  const handleChange = (e) => {
    const selectedValue = e.target.value;
    onChange(selectedValue);
    onSelect?.(selectedValue);
  };

  return (
    <select
      value={value}
      onChange={handleChange}
      role="combobox"
      aria-label="Select frequency"
      className="px-3 py-1 border-0.5 border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-pink focus:border-transparent min-w-[120px]"
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default FrequencyInput;
